import Icon from '../../components/Icon.vue'

Icon.register({"brands/gg":{"width":512,"height":512,"paths":[{"d":"M179.2 230.4L281.6 332.8 179.2 435.2 0 256 179.2 76.8 224 121.6 198.4 147.2 179.2 128 51.2 256 179.2 384 230.7 332.5 153.6 256 179.2 230.4zM332.8 76.8L230.4 179.2 332.8 281.6 358.4 256 281.3 179.5 332.8 128 460.8 256 332.8 384 313.6 364.8 288 390.4 332.8 435.2 512 256 332.8 76.8z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/gg.js
// module id = RirD
// module chunks = 0